import { AxiosPromise, AxiosResponse, CancelToken } from 'axios';
import { apiService } from '@app/services';

class MyProfileService {
    readonly apiBase = '/api/profile/me';

    getMfaCredentialsForInstall(): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/mfa`, {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    mfaVerify(passCode: string): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/mfa/verify`, {
                local: true,
                passCode,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    testOtp(passcode: string): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/mfa/test`, {
                local: true,
                passcode,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    testPush(): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/mfa/testpush`, {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getProviders(): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/mfa/providers`, {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    u2fRegister(onSuccess: Function): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/u2f/register`, {
                local: true,
                onSuccess,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    u2fTestGet(): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/mfa/testu2f`)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
    
    u2fTestPost(u2fData: Object): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/mfa/testu2f`, u2fData)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
    
    u2fPostRegister(u2fResponse: Object): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/u2f/register`, {
                local: true,
                ...u2fResponse,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    mfaWaitForRegister(registrationId: string, cancelToken: CancelToken): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/mfa/registered/${registrationId}`, {
                local: true,
                cancelToken,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    mfaWaitForPush(registrationId: string, onError: Function, onSuccess: Function): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/mfa/registered/${registrationId}/verify`, {
                local: true,
                onSuccess,
                onError,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getMyProfile(): AxiosPromise {
        return apiService
            .get(this.apiBase, {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getMyProfileWithGrants(): AxiosPromise {
        return apiService
            .get('/api/directory/me?$expand=Grants', {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    deleteGrant(identityId: string, grantId: string): AxiosPromise {
        return apiService
            .delete('/api/directory/me(' + identityId + ')/Grants(' + grantId + ')', {
                local: true,
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getDefaults(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/defaults`, { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    checkPhone(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/checkPhone`, jsonObject, {
                local: true,
                onError: handleError,
                onSuccess: handleSuccess,
            })
            .catch();
    }

    checkPhoneProof(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .post(`${this.apiBase}/phone/checkPhoneProof`, jsonObject, {
                local: true,
                onError: handleError,
                onSuccess: handleSuccess,
            })
            .catch();
    }

    checkPassword(jsonObject: any, handleSuccess: Function): AxiosPromise {
        return apiService
            .post(this.apiBase + '/password', jsonObject, {
                local: true,
                onSuccess: handleSuccess,
            })
            .catch();
    }

    putPassword(jsonObject: any, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService
            .put(this.apiBase + '/password', jsonObject, {
                local: true,
                onSuccess: handleSuccess,
                onError: handleError,
            })
            .catch();
    }
}

export const myProfileService = new MyProfileService();
